import { Subscription } from '@services/subscription/types/subscription';
import AppState from '../state';

export const getActiveSubscription = (
  state: AppState
): Subscription | undefined => {
  if (state.artist.active?.id) {
    const artistSubs = state.subscriptionManager.summary?.artists.find(
      (a) => a.id === state.artist.active?.id
    );

    if (artistSubs) {
      const activeSub = artistSubs.subscriptions.find(
        (s) => s.isActive && s.type === 'trac-pro'
      )?.subscription;

      if (activeSub) {
        return activeSub;
      }

      if (
        state.subscription.current?.isActive &&
        state.subscription.current?.key === 'trac_pro'
      ) {
        return state.subscription.current;
      }
    }
  }
};

export const hasActiveSubscription = (state: AppState): boolean => {
  return (
    !!getActiveSubscription(state) || !!localStorage.getItem('Trac.PayAsYouGo')
  );
};

export const getMerchSubscription = (
  state: AppState
): Subscription | undefined => {
  if (state.artist.active?.id) {
    const artistSubs = state.subscriptionManager.summary?.artists.find(
      (a) => a.id === state.artist.active?.id
    );

    if (artistSubs) {
      return artistSubs.subscriptions.find((s) => s.type === 'merch')
        ?.subscription;
    }
  }
};

export const getLabelSubscription = (
  state: AppState
): Subscription | undefined => {
  return state.subscriptionManager.summary?.recordLabels
    .find((a) => a.subscriptions.some((s) => s.isActive))
    ?.subscriptions.find((s) => s.isActive)?.subscription;
};
